import NavigationtBar from "components/NavigationBar/NavigationBar";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import TopBar from "components/TopBar/TopBar";
import SideBar from "components/SideBar/SideBar";
import React from "react";

const Main = ({
	children,
	title: titleProps,
	disableNavigationBar = false,
	enableBackToPrevPage = false,
	enableSearching = false,
	handleSearch,
	colorInvert = false,
	titleIcon,
	titleAlign = "center",
}: {
	children: React.ReactNode;
	title: string | React.ReactNode;
	disableNavigationBar?: boolean;
	enableBackToPrevPage?: boolean;
	enableSearching?: boolean;
	handleSearch?: Function;
	colorInvert?: boolean;
	titleIcon?: React.ReactNode;
	titleAlign?: "left" | "center" | "right";
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));
	const [sidebarOpen, setSidebarOpen] = React.useState(false);

	return (
		<>
			<TopBar
				title={titleProps}
				enableBackToPrevPage={enableBackToPrevPage}
				enableSearching={enableSearching}
				handleSearch={handleSearch}
				colorInvert={colorInvert}
				titleIcon={titleIcon}
				titleAlign={titleAlign}
				onMenuClick={() => setSidebarOpen(true)}
			/>
			<SideBar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
			<Box height={colorInvert ? 0 : 48} />
			<Box
				display="flex"
				flex="1 1 auto"
				overflow="hidden">
				<Box
					component={"main"}
					flex="1 1 auto"
					overflow="auto"
					sx={{ backgroundColor: theme.palette.background.level2 }}>
					{children}
				</Box>
			</Box>
			{!disableNavigationBar && <NavigationtBar />}
		</>
	);
};

export default Main;
